import React, { type ComponentType } from 'react';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { isBrowseLoading, getArticlesLoading } from '../../../state/selectors/browse/index.tsx';
import { AsyncBulkUpdateCategories } from '../../knowledge-hub-bulk-update-categories-async/index.tsx';
import AllArticlesTable, { type AllArticlesTableProps } from './view.tsx';

type StateProps = {
	isInitiallyLoading: boolean;
	isSearchLoading: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	KnowledgeHubBulkUpdateCategories: ComponentType<any /* AsyncBulkUpdateCategories(../../knowledge-hub-bulk-update-categories-async) */>;
};

const AllArticlesTableWithRouteDetails = (props: AllArticlesTableProps) => (
	<AllArticlesTable {...props} />
);

export default connect(
	(state): StateProps => ({
		// @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
		isInitiallyLoading: isBrowseLoading(state, 'all-articles'),
		KnowledgeHubBulkUpdateCategories: AsyncBulkUpdateCategories,
		// @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
		isSearchLoading: getArticlesLoading(state),
	}),
	{},
)(AllArticlesTableWithRouteDetails);
